/**
 * Filter menu script
 */
class P_Menu {
	constructor() {
		this.initState();
	}

	initState() {
		this.header = $('.header');

		if (this.header.length) {
			this.initEvents();
		}
	}

	initEvents() {
		this.headerMenuButton = this.header.find('.toggle-menu');
		this.headerMenu = this.header.find('.header-menu-left');
		this.headerSubMenuButton = this.headerMenu.find('.menu-item-has-children');
		this.headerSubMenuButton.append('<span class="arrow"></span>');
		this.mobileViewport = window.matchMedia('(max-width: 1024px)');

		if (this.mobileViewport.matches) {
			this.mobileMenu();
		}

		this.mobileViewport.addListener(mq => {
			if (mq.matches) {
				this.mobileMenu();
			}
		});
	}

	mobileMenu() {
		this.headerMenuButton.on('click', (e) => {
			e.preventDefault();
			this.header.toggleClass('active');
			this.headerMenuButton.toggleClass('active');
			$('body').toggleClass('no-scroll');
		})

		if (this.headerSubMenuButton) {
			for (let i = 0; i < this.headerSubMenuButton.length; i++) {
				this.headerSubMenuButton.eq(i).children('a').on('click', (e) => {
					e.preventDefault();

					this.headerSubMenuButton.each(function (i, item) {
						$(item).toggleClass('hidden');
						setTimeout(() => {
							$(item).toggleClass('absolute');
						}, 200);
					});

					this.headerSubMenuButton.eq(i).toggleClass('active');
					this.header.find('.header-menu-right').toggleClass('hidden');

					setTimeout(() => {
						this.header.find('.header-menu-right').toggleClass('absolute');
						this.headerSubMenuButton.eq(i).toggleClass('absolute');
					}, 200);

					setTimeout(() => {
						this.headerSubMenuButton.eq(i).removeClass('absolute');
						this.headerSubMenuButton.eq(i).removeClass('hidden');
					}, 10);
				})
			}
		}
	}
}
